import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentTeam } from '@/providers/TeamProvider';
import { TeamElement } from '@/features/w/[identifier]/setting/teams/[team_id]/{components}/TeamElement';
import { TeamMembersElement } from '@/features/w/[identifier]/setting/teams/[team_id]/{components}/TeamMembersElement';
import { TeamSalesOrderPhasesElement } from '@/features/w/[identifier]/setting/teams/[team_id]/{components}/TeamSalesOrderPhasesElement';
import { PurchaseOrderPhasesElement } from '@/features/w/[identifier]/setting/teams/[team_id]/{components}/TeamPurchaseOrderPhasesElement';
import { MonthlySalesTargetsElement } from '@/features/w/[identifier]/setting/teams/[team_id]/{components}/MonthlySalesTargetsElement';
import { MonthlyOrderingBudgetsElement } from '@/features/w/[identifier]/setting/teams/[team_id]/{components}/MonthlyOrderingBudgetsElement';
import { TeamPhaseSkipSettingElement } from '@/features/w/[identifier]/setting/teams/[team_id]/{components}/TeamPhaseSkipSettingElement';

export const WorkspaceTeam = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('チーム詳細'), []);
  useEffect(() => setBreadcrumbs([{ label: `チーム設定`, path: `/w/${_w_!.identifier}/setting/teams` }]), []);

  const { _w_, me, _t_, isAdmin } = useCurrentTeam();

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'team'} />

        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <TeamElement />

            <TeamMembersElement />

            <MonthlySalesTargetsElement />

            <MonthlyOrderingBudgetsElement />

            <TeamSalesOrderPhasesElement />

            <PurchaseOrderPhasesElement />

            <TeamPhaseSkipSettingElement />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
